import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'loyaltic-cookie',
    templateUrl: './cookie.component.html',
    styleUrls: ['./cookie.component.scss'],
    standalone: false
})
export class CookieComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
